var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-col antialiased text-xs text-pastel-black h-full"},[_c('l-header'),_c('l-toolbar',[_c('l-menu')],1),_c('div',{staticClass:"flex-grow"},[_c('router-view')],1)],1),_c('vue-toastify',{staticStyle:{"z-index":"999"},attrs:{"withBackdrop":true,"position":"top-center","lightTheme":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }